<template>
  <div id="vote_intro_nomination_period">
    
    <h4>Time to vote!</h4>

    <p>
      We crunched the numbers and now have the official finalists.
    </p>

    <p>
      Your favorites can't win without your support, so make sure you're showing them some love each and every day.
    </p>

    <b-button
    v-if="!show_voting_instructions"
    size="sm"
    variant="link"
    @click="toggle_voting_instructions"
    >How does voting work?</b-button>

    <transition
    name="" 
    mode="out-in"
    enter-active-class="animated fadeIn faster" 
    leave-active-class="animated fadeOut faster"
    >

      <div class="voting_instructions"
      v-if="show_voting_instructions"
      >
        <p>
          <strong>How does voting work?</strong> You can vote for you favorites everyday. Make sure you know who you want to win though, because <em>you can only vote once per day</em> on each of the 130+ contests. Every vote counts so make them great!
        </p>

        <p>
          Looking for something specific? Try the search icon <font-awesome-icon icon="search"></font-awesome-icon> in the top-right corner of your screen.
        </p>

        <p>
          Just wanna vote? Don't care where you start? Mash the big button below and have fun!
        </p>

        <b-button
        size="sm"
        variant="link"
        @click="toggle_voting_instructions"
        >Hide instructions</b-button>

      </div>

    </transition>
    

    <large-centered-button
    v-if="is_logged_in"
    button_text="RANDOMIZE"
    icon="check-double"
    width="full"
    @button_clicked="goto_path('/votenow')"
    ></large-centered-button>

    <p class="text-center"
    v-if="is_logged_in"
    >
      <strong style="font-size: 2em;">OR</strong>
    </p>

  </div>
</template>

<script>
import LargeCenteredButton from '@/components/buttons/large_centered_button.vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
library.add(faSearch);

export default {
  name: 'vote_intro_nomination_period',
  props: [
    'is_logged_in'
  ],
  data () {
    return {
      show_voting_instructions: false
    }
  },
  methods: {
    goto_path: function(path_name) {
      this.$root.store.goto_path(path_name);
    },
    toggle_voting_instructions: function() {
      this.show_voting_instructions = !this.show_voting_instructions;
    }
  },
  computed: {
    
  },
  components: {
    LargeCenteredButton
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

</style>


// WEBPACK FOOTER //
// src/features/vote/intros/vote_intro_voting_period.vue